import React from 'react'
import "./ResumeBtn.css"
import { LuDownload } from 'react-icons/lu'
const ResumeBtn = () => {
    return (
        <div className=''>
            <div className="button px-6 py-3 before:bg-gradient-to-br before:from-purple-700 before:to-blue-700">
                <div className="dots_border"></div>
                <span className="text_button inline-flex gap-2 font-semibold justify-center items-center ">
                    Resume <LuDownload size={18} className='text-white' />
                </span>
            </div>

        </div>
    )
}

export default ResumeBtn